import React from "react";
import { numeroConComas }
	from "./numero"

/*
	Tarjeta de indicador. La regla de color es la del mockup, con el oro en el
	lugar del rojo: arriba de 0 en oro cuando es algo que hay que resolver,
	en 0 en negro. Los de venta no son alarma, van siempre en naranja.
*/

interface Props {
	etiqueta: string;
	/* aclaracion corta entre parentesis, p. ej. "(+15%)" */
	matiz?: string;
	valor: number | null;
	/* denominador real, no una explicacion: "de 1,245" */
	de?: number | null;
	icono: React.ReactNode;
	/* "alerta" pinta oro cuando hay algo pendiente; "venta" siempre naranja */
	tipo: "alerta" | "venta";
	cargando: boolean;
}

const KpiCard = ({ etiqueta, matiz, valor, de, icono, tipo, cargando }: Props) => {
	const estado = tipo === "venta" ? undefined : valor === 0 ? "zero" : "alert";

	return (
		<div className="wt-kpi" data-state={estado}>
			<span className="wt-label">
				<span className="wt-icon" aria-hidden="true">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
						strokeLinecap="round" strokeLinejoin="round">
						{icono}
					</svg>
				</span>
				{etiqueta}{matiz ? <i>&nbsp;{matiz}</i> : null}
			</span>
			<span className="wt-figure">
				{cargando || valor === null
					? <span className="wt-n wt-skeleton">000</span>
					: <span className="wt-n">{numeroConComas(valor)}</span>}
				{!cargando && valor !== null && de ? (
					<span className="wt-of">de {numeroConComas(de)}</span>
				) : null}
			</span>
		</div>
	);
};

export default KpiCard;
